var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 5.281l2.526-2.97A1.248 1.248 0 008.625.25c-.354 0-.705.15-.952.44C1.987 7.38.5 8.59.5 11.5a6.257 6.257 0 006.25 6.25A6.257 6.257 0 0013 11.5c0-3.344-2.645-6.059-5.95-6.219zm-.3 9.969A3.754 3.754 0 013 11.5c0-2.068 1.682-3.715 3.75-3.715S10.5 9.467 10.5 11.5s-1.684 3.75-3.75 3.75z",
    fill: "#00B9EF"
  })));
}

export default SvgSix;